import useIsMounted from "@hooks/useIsMounted";
import { Box, Fade, LinearProgress } from "@mui/material";
import React, { Fragment, useEffect } from "react";

import { useMeta } from "./provider";

interface Props {
  children: React.ReactNode;
}

const MetaComponent: React.FC<Props> = ({ children }) => {

  const [metaState, { setMeta }] = useMeta();
  const isMounted = useIsMounted()
  console.log("metaState", metaState)

  return (
    <Fragment>
      {metaState.isLoading && <LinearProgress sx={{zIndex: 1000}}/>}
      {children}
    </Fragment>
  );
};

export default MetaComponent;
